import * as axios from "axios";
import CONFIG from "../../config";
import { getAuthHeader } from "../../utils";

export const postDrive = (model) => {
  const url = `${CONFIG.BASE_URL}/jobdrive/add-drive`;
  return axios.post(url, model, getAuthHeader()).then((response) => {
    return response.data;
  });
};
export const listDrive = (model) => {
  const url = `${CONFIG.BASE_URL}/jobdrive/jobdrivelist`;
  return axios.post(url, model, getAuthHeader()).then((response) => {
    return response.data;
  });
};
export const getdriveDetails = (model) => {
  const url = `${CONFIG.BASE_URL}/jobdrive/getjobdrivedetail`;
  return axios.post(url, model, getAuthHeader()).then((response) => {
    return response.data;
  });
};

export const postInstitutionDriveApproval = (model) => {
  const url = `${CONFIG.BASE_URL}/jobdrive/drive-approveby-institute`;
  return axios.post(url, model, getAuthHeader()).then((response) => {
    return response.data;
  });
};

export const getListInstitutionJobApproval = (model) => {
  const url = `${CONFIG.BASE_URL}/jobdrive/drive-message`;
  return axios.post(url, model, getAuthHeader()).then((response) => {
    return response.data;
  });
};
export const applyOnDrive = (model) => {
  const url = `${CONFIG.BASE_URL}/candidate/candidateapplydrive`;
  return axios.post(url, model, getAuthHeader()).then((response) => {
    return response.data;
  });
};
export const selectCandidate = (model) => {
  const url = `${CONFIG.BASE_URL}/candidate/candidateselectdrive`;
  return axios.post(url, model, getAuthHeader()).then((response) => {
    return response.data;
  });
};

export const CandidateAppliedDriveList = (model) => {
  const url = `${CONFIG.BASE_URL}/jobdrive/candidateapplydrive`;
  return axios.post(url, model, getAuthHeader()).then((response) => {
    return response.data;
  });
};
